export function downloadFile (data,name){

    var fileURL = window.URL.createObjectURL(new Blob([data], {type:'application/*'}));
    var fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', name);
    document.body.appendChild(fileLink);

    fileLink.click();
}